import { useEffect, useMemo, useState } from "react";
import InputSearchSelect, { type SelectOption } from "./InputSearchSelect";
import { getConfigurationByKey } from "@/lib/services/configuration";
import { CONFIGURATION } from "@/constants/constants";

type Props = {
  id: string;
  size: "large" | "medium" | "small";
  label?: string;
  placeholder?: string;
  required?: boolean;
  titleInPanel?: string;
  disabled?: boolean;
  name?: string;
  error?: boolean;
  value?: string | null;
  onChange?: (value: string) => void;
};

const memoryCache = new Map<string, SelectOption[]>();
const cacheKey = "findingsNacelleOptions";

export default function NacelleFinfingsInputSearchSelect({ ...rest }: Props) {
  const [options, setOptions] = useState<SelectOption[]>(() => {
    return memoryCache.get(cacheKey) ?? [];
  });
  const [loading, setLoading] = useState<boolean>(
    () => !memoryCache.has(cacheKey),
  );
  const [errorLoading, setErrorLoading] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      if (memoryCache.has(cacheKey)) return;

      try {
        setLoading(true);
        setErrorLoading(null);
        const data = await getConfigurationByKey(
          CONFIGURATION.FINDINGS_NACELLE,
        );
        if (!mounted) return;
        const list = data.map((it) => ({ label: it, value: it }));
        memoryCache.set(cacheKey, list);
        setOptions(list);
      } catch {
        if (!mounted) return;
        setErrorLoading("No se pudieron cargar las opciones");
      } finally {
        setLoading(false);
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, []);

  const finalDisabled = rest.disabled || loading;

  const titleInPanel = useMemo(() => {
    if (loading) return "Cargando…";
    if (errorLoading) return errorLoading;
    return rest.titleInPanel;
  }, [loading, errorLoading, rest.titleInPanel]);

  return (
    <InputSearchSelect
      {...rest}
      disabled={finalDisabled}
      titleInPanel={titleInPanel}
      options={options}
    />
  );
}
